import { Pencil, ShieldCheck, BarChart3 } from "lucide-react";

function GameActionButtons({
   editMode,
   setEditMode,
   editFinalScores,
   setEditFinalScores,
   handleSubmit,
   isSaving,
   setShowModal,
   setFormData,
   game,
   originalStatValues,
   setStatValues,
   originalFinalScoreForm,
   setFinalScoreForm,
   usesPlayerStatsTable,
   isRacquetSport,
}) {
   const hasBothTeams = Boolean(game?.home_team_id && game?.away_team_id);
   const hasBothPlayers = Boolean(game?.home_player_id && game?.away_player_id);
   const hasBothSides = hasBothTeams || hasBothPlayers;

return (
      <div className="edit-actions game-action-buttons">
      {usesPlayerStatsTable && hasBothSides && !editFinalScores && (
            <button
               type="button"
               className={`game-action-button ${editMode ? "game-action-danger-button" : ""}`}
               onClick={() => {
                  if (editMode) {
                     setStatValues(originalStatValues);
                     setEditMode(false);
                     return;
                  }

                  setFinalScoreForm(originalFinalScoreForm);
                  setEditFinalScores(false);
                  setEditMode(true);
               }}
            >
               <BarChart3 size={18} strokeWidth={2.2} />
               <span>{editMode ? "Cancel" : "Edit Stats"}</span>
            </button>
         )}

         {editMode && (
            <button
               type="button"
               className="game-action-button game-action-save-button"
               onClick={handleSubmit}
               disabled={isSaving}
            >
               <span>{isSaving ? "Saving..." : "Save Stats"}</span>
            </button>
         )}

         {!editMode && hasBothSides && !editFinalScores && (
            <button
               type="button"
               className="game-action-button"
               onClick={() => {
                  setStatValues(originalStatValues);
                  setEditMode(false);
                  setEditFinalScores(true);
               }}
            >
               <ShieldCheck size={18} strokeWidth={2.2} />
               <span>
                  {isRacquetSport
                     ? game?.isIndividualGame
                        ? "Override Individual Score"
                        : "Override Team Score"
                     : "Edit Final Scores"}
               </span>
            </button>
         )}

         {!editMode && !editFinalScores && (
            <button
               type="button"
               className="game-action-button"
               onClick={() => {
                  setStatValues(originalStatValues);
                  setFinalScoreForm(originalFinalScoreForm);
                  setEditMode(false);
                  setEditFinalScores(false);

                  setShowModal(true);
                  setFormData({
                     video_url: game?.video_url || "",
                     location: game?.location || "",
                     location_url: game?.location_url || "",
                     date: game?.date || "",
                     time: game?.time || "",
                  });
               }}
            >
               <Pencil size={18} strokeWidth={2.2} />
               <span>Edit Game</span>
            </button>
         )}
      </div>
   );
}

export default GameActionButtons;